export const getPastDateAsString = (noOfDays) => {
  let d = new Date();
  d.setDate(d.getDate() - noOfDays);

  return d.toLocaleDateString('en-ZA').split( '/' ).join('-');
}
